import { fromJS } from '@gonfalon/immutable-shim/immutableShim';

import { PendingChangesFormRecord } from './records/PendingChangesFormRecord';
import { type PendingChangesFormRecordProps } from './types';

export function createPendingChangesForm(
  props: Partial<PendingChangesFormRecordProps> | PendingChangesFormRecord = {},
) {
  return props instanceof PendingChangesFormRecord ? props : new PendingChangesFormRecord(fromJS(props));
}
